import React from 'react'
import "./ImageSection.css";
import styled from 'styled-components';
import resume from '../img/resume.jpg';
import { Button } from '@material-ui/core';
import emoji from "react-easy-emoji";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDatabase,faFire } from '@fortawesome/free-solid-svg-icons'
import { faGithub,faHtml5,faCss3Alt,faSass,faJs,faReact,faNode,faNpm } from '@fortawesome/free-brands-svg-icons'

function ImageSection() {
    const skillsSection = {
        title: "What I do",
        subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
        skills: [
          emoji(
            "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
          ),
          emoji("⚡ Progressive Web Applications in normal "),
          emoji(
            "⚡ Integration of third party services such as Firebase/ Heroku / Netlify"
          )
        ]
      };
    return (
        <ImageSectionStyled>
            <div className="left-content">
                <img src={resume} alt=""/>
            </div>
            <div className="right-content">
                <h4>I am <span>Nadim</span></h4>
                <h5>{skillsSection.subTitle}</h5>
                <p>{skillsSection.skills[0]}</p>
                <p>{skillsSection.skills[1]}</p>
                <p>{skillsSection.skills[2]}</p>
                    <div className="software-skills-main-div">
                        <ul className="dev-icons">
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faHtml5} />
                                <p>html-5</p>
                            </li>
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faCss3Alt} />
                                <p>css3</p>
                            </li>
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faSass} />
                                <p>sass</p>
                            </li>
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faJs} />
                                <p>JavaScript</p>
                            </li>
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faReact} />
                                <p>reactjs</p>
                            </li>
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faNode} />
                                <p>nodejs</p>
                            </li>
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faNpm} />
                                <p>npm</p>
                            </li>
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faDatabase} />
                                <p>MongoDB</p>
                            </li>
                            <li className="software-skill-inline">
                                <FontAwesomeIcon icon={faFire} />
                                <p>firebase</p>
                            </li>
                        </ul>
                    </div>
                <div className="about-info">
                    <div className="info-title">
                        <p>Full Name</p>
                        <p>Age</p>
                        <p>Nationality </p>
                        <p>Languages </p>
                        <p>Location</p>
                        <p>Service</p>
                    </div>
                    <div className="info">
                        <p>: Abdul Awal Nadim </p>
                        <p>: 25</p>
                        <p>: Bangladeshi </p>
                        <p>: Bengali, English </p>
                        <p>: Chattogram, Bangladesh</p>
                        <p>: Freelance</p>
                    </div>
                </div>
                <Button variant="contained" color="primary" href="https://drive.google.com/file/d/1F8gDKhethKOY83eMUIU6fN3WJQsKSIMq/view" target="_blank">View Resume</Button>
            </div>
        </ImageSectionStyled>
    )
}


const ImageSectionStyled = styled.div`
    margin-top: 5rem;
    display: flex;
    @media screen and (max-width:1000px){
        flex-direction: column;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    .left-content{
        width: 100%;
        img{
            width: 95%;
            object-fit: cover;
        }
    }
    .right-content{
        width: 100%;
        h4{
            font-size: 2rem;
            color: var(--white-color);
            span{
                font-size: 2rem;
            }
        }
        .paragraph{
            padding: 1rem 0;
        }
        .about-info{
            display: flex;
            padding-bottom: 1.4rem;
            .info-title{
                padding-right: 3rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p{
                    padding: .3rem 0;
                }
            }
        }
    }
`;
export default ImageSection;
